
import { defineComponent } from 'vue'
import EncounterDetail from './EncounterDetail.vue'
import PatientSearch from '../shared/PatientSearch.vue'
import EncounterTimeLine from './EncounterTimeLine.vue'

export default defineComponent({
  name: 'PatientEncounters',
  components: { 
    EncounterDetail, 
    PatientSearch,  
    EncounterTimeLine
  },
  data () {
    return {
      patient: null,
      newEncounter: false,
      searchPatient: false,
    }
  },
  methods: {
    onSearch() {
      this.searchPatient = true
      this.patient = null
      this.newEncounter = false
    },
    onNew() {
      this.searchPatient = false
      this.newEncounter = true
    },
    onCancel() {
      this.newEncounter = false
    },
    selectedPatient(selectedPatient) {
      this.patient = selectedPatient
      this.searchPatient = false
    }
  },
  mounted () {
    this.patient = null
    this.searchPatient = true
  }
})
